import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { AdminDashboardRevenue, AdminDashboardSectionState } from "@/types/dashboard";

export type DashboardRevenueState = AdminDashboardSectionState<AdminDashboardRevenue>;

export const dashboardRevenueInitialState: DashboardRevenueState = {
  data: null,
  error: null,
};

const slice = createSlice({
  name: "dashboardRevenue",
  initialState: dashboardRevenueInitialState,
  reducers: {
    setDashboardRevenueAction(state, { payload }: PayloadAction<AdminDashboardRevenue | null>) {
      state.data = payload;
      state.error = null;
    },
    setDashboardRevenueErrorAction(state, { payload }: PayloadAction<string | null>) {
      state.error = payload;
    },
  },
});

export const { setDashboardRevenueAction, setDashboardRevenueErrorAction } = slice.actions;
export default slice.reducer;
